import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const EventDetailContainer = styled.div`
  min-height: 100vh;
  background: #fff;
  animation: ${fadeIn} 0.6s ease;
`;

export const EventHero = styled.div`
  position: relative;
  height: 60vh;
  width: 100%;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 70%;
    background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);
  }
`;

export const HeroImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const EventInfo = styled.div`
  position: absolute;
  bottom: 4rem;
  left: 0;
  right: 0;
  z-index: 1;
  color: white;
  padding: 0 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

export const EventTitle = styled.h1`
  font-size: 3.5rem;
  font-weight: 500;
  margin-bottom: 1rem;
  line-height: 1.2;
`;

export const EventMeta = styled.div`
  display: flex;
  gap: 2rem;
  font-size: 1.1rem;
  margin-bottom: 1rem;

  div {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  svg {
    font-size: 1.3rem;
  }
`;

export const EventCategory = styled.span`
  background: #000;
  color: white;
  padding: 0.5rem 1.5rem;
  border-radius: 30px;
  font-size: 1rem;
  display: inline-block;
  margin-bottom: 1rem;
`;

export const ContentSection = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 4rem 2rem;
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 4rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const MainContent = styled.div`
  h2 {
    font-size: 2rem;
    font-weight: 500;
    margin-bottom: 1.5rem;
    color: #000;
  }

  p {
    font-size: 1.1rem;
    line-height: 1.8;
    color: #444;
    margin-bottom: 2rem;
  }
`;

export const Sidebar = styled.div`
  background: #f8f8f8;
  padding: 2rem;
  border-radius: 20px;
  position: sticky;
  top: 2rem;
  height: fit-content;
`;

export const DetailItem = styled.div`
  margin-bottom: 2rem;

  h3 {
    font-size: 1.2rem;
    font-weight: 500;
    margin-bottom: 1rem;
    color: #000;
  }

  p {
    color: #666;
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      padding: 0.5rem 0;
      color: #666;
      border-bottom: 1px solid #eee;

      &:last-child {
        border-bottom: none;
      }
    }
  }
`;

export const RegisterButton = styled.button`
  width: 100%;
  background: #000;
  color: white;
  border: none;
  padding: 1rem;
  font-size: 1.1rem;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 1rem;

  &:hover {
    background: #333;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }
`;

export const BackButton = styled.button`
  position: fixed;
  top: 2rem;
  left: 2rem;
  z-index: 10;
  background: white;
  border: none;
  padding: 1rem;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    font-size: 1.5rem;
  }

  &:hover {
    transform: translateX(-5px);
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
  }
`; 